
export default function QuoteValueSection() {
  return (
    <section className="py-16 bg-gray-50">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl lg:text-4xl font-bold text-gray-900 mb-4">
            Why Smart Homeowners Get Quotes First
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            Even if you're not ready to start your project, getting quotes early gives you the knowledge and confidence to make better decisions.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8 mb-12">
          <div className="bg-white rounded-xl p-6 shadow-lg hover:shadow-xl transition-shadow">
            <div className="w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center mb-4">
              <i className="ri-calculator-line text-2xl text-blue-600"></i>
            </div>
            <h3 className="text-xl font-semibold text-gray-900 mb-3">Budget Like a Pro</h3>
            <p className="text-gray-600 mb-4">
              Know the real cost before you start saving. Avoid the shock of discovering your dream bathroom costs twice what you expected.
            </p>
            <div className="bg-blue-50 rounded-lg p-3">
              <p className="text-sm text-blue-700 font-medium">
                "I saved for 8 months based on my quote. When I was ready, no financial surprises!"
              </p>
            </div>
          </div>

          <div className="bg-white rounded-xl p-6 shadow-lg hover:shadow-xl transition-shadow">
            <div className="w-12 h-12 bg-green-100 rounded-lg flex items-center justify-center mb-4">
              <i className="ri-shield-line text-2xl text-green-600"></i>
            </div>
            <h3 className="text-xl font-semibold text-gray-900 mb-3">Avoid Contractor Traps</h3>
            <p className="text-gray-600 mb-4">
              Learn what quality work actually costs. Spot overpriced quotes and lowball scams before they happen.
            </p>
            <div className="bg-green-50 rounded-lg p-3">
              <p className="text-sm text-green-700 font-medium">
                "My quote helped me spot a contractor trying to overcharge by $8,000!"
              </p>
            </div>
          </div>

          <div className="bg-white rounded-xl p-6 shadow-lg hover:shadow-xl transition-shadow">
            <div className="w-12 h-12 bg-purple-100 rounded-lg flex items-center justify-center mb-4">
              <i className="ri-time-line text-2xl text-purple-600"></i>
            </div>
            <h3 className="text-xl font-semibold text-gray-900 mb-3">Plan Your Timeline</h3>
            <p className="text-gray-600 mb-4">
              Understand how long your project will take. Plan around holidays, events, and your family's schedule.
            </p>
            <div className="bg-purple-50 rounded-lg p-3">
              <p className="text-sm text-purple-700 font-medium">
                "Knowing the timeline helped us plan around our daughter's wedding!"
              </p>
            </div>
          </div>
        </div>

        <div className="bg-gradient-to-r from-blue-600 to-purple-600 rounded-2xl p-8 text-white">
          <div className="text-center">
            <div className="flex items-center justify-center mb-4">
              <div className="bg-white/20 rounded-full p-3">
                <i className="ri-lightbulb-line text-3xl"></i>
              </div>
            </div>
            <h3 className="text-2xl font-bold mb-4">The Quote Advantage</h3>
            <p className="text-lg text-blue-100 mb-6 max-w-2xl mx-auto">
              Getting a quote doesn't mean you have to start your project tomorrow. It means you'll be prepared when you're ready.
            </p>
            
            <div className="grid md:grid-cols-2 gap-6 max-w-4xl mx-auto">
              <div className="bg-white/10 rounded-lg p-4">
                <h4 className="font-semibold mb-2">Without a Quote:</h4>
                <ul className="text-sm text-blue-100 space-y-1">
                  <li>• Guessing at costs</li>
                  <li>• Vulnerable to overcharging</li>
                  <li>• Rushed decisions</li>
                  <li>• Timeline surprises</li>
                </ul>
              </div>
              
              <div className="bg-white/10 rounded-lg p-4">
                <h4 className="font-semibold mb-2">With a Quote:</h4>
                <ul className="text-sm text-blue-100 space-y-1">
                  <li>• Accurate budgeting</li>
                  <li>• Protected from scams</li>
                  <li>• Confident decisions</li>
                  <li>• Perfect timing</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
